import React from "react";
import { Button, Stack } from "@mui/material";
import styles from "./ContributeButton.module.scss";

const ContributeButton = ({
  title,
  image,
  imageAlt,
  externalURL = null,
  active = false,
  onClick
}) => {
  const props = {};

  if (externalURL) {
    props.href = externalURL;
    props.target = "_blank";
  } else {
    props.onClick = onClick;
  }

  return (
    <Button {...props} className={styles.button}>
      <Stack
        className={[styles.iconButton, active ? styles.active : ""].join(" ")}
      >
        <img src={image} alt={imageAlt} />
      </Stack>
      <span className={styles.title}>{title}</span>
    </Button>
  );
};

export default ContributeButton;
